import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function otpValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null; // required validator will handle this
        }

        const otpPattern = /^\d{6}$/;

        if (!otpPattern.test(value)) {
            return { otp: true };
        }

        return null;
    };
}